import { render, staticRenderFns } from "./buTiePendingList.vue?vue&type=template&id=651058f8&scoped=true&"
import script from "./buTiePendingList.vue?vue&type=script&lang=js&"
export * from "./buTiePendingList.vue?vue&type=script&lang=js&"
import style0 from "./buTiePendingList.vue?vue&type=style&index=0&id=651058f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651058f8",
  null
  
)

export default component.exports